import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { SelectImageResourcePopup } from './SelectImageResourcePopup';

const POPUP_KEY = Symbol('SELECT_IMAGE_RESOURCE');

export const useSelectImageResourcePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, SelectImageResourcePopup);
  });

  /**
   * Open the "Select Image Resource" popup, allowing users to select an image resource.
   *
   * @param {Object} [options] - Options for the popup.
   * @param {Object} [options.selectedImageResource] - The currently selected image resource, if any.
   * @returns {Promise<Object>} - selected image resource or null if cancelled.
   */
  return useCallback(
    ({ selectedImageResource } = {}) => {
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          selectedImageResource,

          onSubmit: (resource) => {
            popups.closePopup(POPUP_KEY);
            resolve(resource);
          },
          onCancel: () => {
            popups.closePopup(POPUP_KEY);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
